module.exports = __webpack_public_path__ + "static/assets/59900a1f0afaace46fdfe95d78c056f6.svg";